import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Careers from './components/Careers';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';
import { COMPANY_NAME } from './constants';

const App = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <header className="bg-gray-900 text-white p-4 flex justify-between items-center">
          <h1 className="text-3xl font-bold mb-0">{COMPANY_NAME}</h1>
          <nav className="space-x-4">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              About Us
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              Services
            </NavLink>
            <NavLink
              to="/careers"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              Careers
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              Contact Us
            </NavLink>
            <NavLink
              to="/privacy"
              className={({ isActive }) =>
                isActive ? 'text-yellow-400 font-semibold' : 'text-white hover:text-yellow-300'
              }
            >
              Privacy Policy
            </NavLink>
          </nav>
        </header>
        <main className="p-6 flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
